module.exports = __webpack_public_path__ + "img/flame.60b46c2b.svg";